import { render, staticRenderFns } from "./mine-about.vue?vue&type=template&id=1ef34871&scoped=true&"
import script from "./mine-about.vue?vue&type=script&lang=js&"
export * from "./mine-about.vue?vue&type=script&lang=js&"
import style0 from "./mine-about.vue?vue&type=style&index=0&id=1ef34871&prod&lang=scss&"
import style1 from "./mine-about.vue?vue&type=style&index=1&id=1ef34871&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef34871",
  null
  
)

export default component.exports